import { HCF } from "@macashipo/mlib"
import { HConstant, HUtils, HLocalStorage } from "src/core/helpers"
import {
  MyPageOne,
  MyUIOne,
  // MyLibOne,
  MyIconOne,
  MyControlOne,
  MyFormControlOne,
  MyControlForm,
  MyTableFilterControlOne,
  // MyTableCellOne,
} from "./components"
import {
  ScreenCode,
  // HomeConfig,
  ConfigPageScreen,
} from "./constants/path"
import "./assets/theme-dnt.scss"
import * as actions from "src/App/App.actions"
import { Sidebar } from "./constants/sidebar"
import { initI18n } from "./lang/i18n"

interface IModuleAppReduce extends ICore.IOneModule {
  runAfterInit: (HConfig: any) => void
}
const ModuleAppReduce: IModuleAppReduce = {
  _key: "app_dnt",
  _fnList: {},
  _config: {},
  getMyKey: () => {
    return "app_dnt"
  },
  runAfterInit: (HConfig: any) => {
    initI18n()
    // TitlePage.initTitlePage()
    Sidebar.init()
    MyPageOne.init()
    MyUIOne.init()
    // MyLibOne.init()
    MyIconOne.init()
    MyControlOne.init()
    MyFormControlOne.init()
    MyControlForm.init()
    MyTableFilterControlOne.init()
    // MyTableCellOne.init()
    const domainTheme = HCF.getCF("appTheme")
    window.document.body.classList.add("theme-dnt")
    window.document.body.classList.add("style-1")
    if (HLocalStorage.getString("dark-theme", "") === "true") {
      window.document.body.classList.add("dark")
    }
    if (domainTheme) {
      window.document.body.classList.add(domainTheme)
    }
    HUtils.runFuntion(HConfig, HConstant.HConfig.FnList.addPrivateRoutes, [
      [
        ConfigPageScreen[ScreenCode.CREATE_TASK],
        ConfigPageScreen[ScreenCode.SEARCH_TASK],
        ConfigPageScreen[ScreenCode.TASK_DETAIL],
        ConfigPageScreen[ScreenCode.MY_PROFILE],
        ConfigPageScreen[ScreenCode.MY_TASKS],
        ConfigPageScreen[ScreenCode.SEARCH_COMMUNICATION],
        ConfigPageScreen[ScreenCode.CREATE_COMMUNICATION],
        ConfigPageScreen[ScreenCode.MY_COMMUNICATIONS],
        ConfigPageScreen[ScreenCode.NOTIFICATIONS],
        ConfigPageScreen[ScreenCode.COMMUNICATION_VIEW],
        ConfigPageScreen[ScreenCode.COMMUNICATION_DETAIL],
        // HomeConfig,
      ],
    ])
    HUtils.runFuntion(HConfig, HConstant.HConfig.FnList.addPublicRoutes, [[]])
    HUtils.runFuntion(
      HConfig.fnList,
      HConstant.HConfig.FnList.dispatchFromStore,
      [actions.sideNavUpdate(Sidebar.list)]
    )
    HUtils.runFuntion(
      HConfig.fnList,
      HConstant.HConfig.FnList.dispatchFromStore,
      [actions.sideButtonUpdate(Sidebar.button_list)]
    )
  },
}

export default ModuleAppReduce
